(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/contextual-menu/assets/javascripts/contextual-menu.js') >= 0) return;  svs.modules.push('/components/components/contextual-menu/assets/javascripts/contextual-menu.js'); 
'use strict';

var svs = svs || {};

svs.components = svs.components || {};

svs.components.ContextualMenu = function() {
  var _options = {},
    _rendered = false,
    _menuType,
    $el = $(
      '<div class="contextual-menu-wrapper hide"><nav class="contextual-menu contextual-menu-drop-down"></nav></div>'
    ),
    _isVisible = true,
    mainContent = $('.js-main-content'),
    menuEl,
    scrollIconLeft,
    scrollIconRight,
    menuContainer,
    scrollElement,
    prevScrollPos = window.pageYOffset || document.documentElement.scrollTop,
    offsetTop;

  function setupListeners() {
    _rendered = false;

    if (_menuType === 'menu') {
      $el.on('click', function(e) {
        if ($(e.target).hasClass('contextual-menu-wrapper')) {
          toggleVisibility();
        }
      });
    }
    if (svs.core.detect.formfactor.desktop() && _options.useIconButtons) {
      menuEl.on('scroll', scrollButtons);
      scrollIconRight.on('click', scrollRight);
      scrollIconLeft.on('click', scrollLeft);
    }

    if (
      svs.core.detect.formfactor.mobile() &&
      _options.useFixedMenu &&
      _options.useIconButtons
    ) {
      scrollElement = menuEl.parents('.js-swiper-container');

      if (scrollElement.length > 0) {
        $(scrollElement).on('scroll', onScroll);
      } else {
        $(window).on('scroll', onScroll);
      }

      if (svs.core.detect.formfactor.mobile()) {
        svs.core.detect.orientation.on('change', onScroll);
      }
    }
    if (svs.core.detect.formfactor.mobile()) {
      svs.core.detect.orientation.on('change', onResize);
    }

    if (
      svs.core.detect.formfactor.desktop() && _options.useIconButtons ||
      _options.useFixedMenu
    ) {
      $(window).on('resize', onResize);
    }
  }

  function setMenuFunctionality(options) {
    _options = options;

    if (options.showMenuInHeader === undefined) {
      _options.showMenuInHeader =
        svs.core.data.capabilities.formFactor === 'mobile';
    } else {
      _options.showMenuInHeader = options.showMenuInHeader;
    }

    if (_options.showMenuInHeader) {
      $('body').append($el);
    }

    if (_options.buttons) {
      _options.rightButtons = [];
      _options.rightButtons = [];
      _options.leftButtons = convertButtonsToNewSyntax(_options.buttons);
    } else {
      _options.rightButtons = _options.rightButtons
        ? _options.rightButtons
        : [];
      _options.leftButtons = _options.leftButtons ? _options.leftButtons : [];
    }

    close();

    reset();

    if (!_options.showMenuInHeader) {
      render();
    } else {
      var $button = $('.js-top-contextual');
      if (_options.wrapper) {
        $button.addClass(_options.wrapper);
      }

      if (Object.prototype.hasOwnProperty.call(_options, 'visible') && _options.visible === false) {
        $button.css('display', 'none');
        reset();
      } else {
        $button.css('display', 'inline-block');
        _menuType = Object.prototype.hasOwnProperty.call(_options, 'menuType')
          ? _options.menuType
          : 'menu';
        var iconClass = Object.prototype.hasOwnProperty.call(_options, 'icon')
          ? _options.icon
          : 'icon-nav-more-vertical';

        if (_menuType === 'textButton') {
          _options.cssClass = 'js-top-contextual-icon top-contextual-button';
          $button.html(getButton(_options, true));
        } else {
          if (_isVisible) {
            $button.html(
              '<i class="js-top-contextual-icon top-contextual-icon icon-default icon-200 ' +
              iconClass +
              '"></i>'
            );
          } else {
            $button.html(
              '<i class="hide js-top-contextual-icon top-contextual-icon icon-default icon-200 ' +
              iconClass +
              '"></i>'
            );
          }
        }
        if (_options.surroundAnchor) {
          $button.prop('href', _options.surroundAnchor);
        }

        if (_menuType === 'menu') {
          render();
        }
      }
    }

    setupListeners();
  }

  function render() {
    if (_options) {
      if (_options.showMenuInHeader) {
        renderMobileButtons(
          _options.leftButtons.concat(_options.rightButtons)
        );
      } else {
        if (_options.useIconButtons) {
          renderIconButtons(
            _options.leftButtons.concat(_options.rightButtons)
          );
        } else {
          renderTabletButtons(
            _options.leftButtons,
            _options.rightButtons,
            _options.leftButtonsInBlock
          );
        }
      }
    }
  }

  function onScroll() {
    var scroll = window.pageYOffset || document.documentElement.scrollTop;

    if (svs.core.detect.orientation.isPortrait()) {
      if (isScrolledIntoView(scroll)) {
        menuEl.removeClass('contextual-menu-swipe-fixed');
      } else {
        menuEl.addClass('contextual-menu-swipe-fixed');
        if (scroll < prevScrollPos) {
          menuEl.addClass('contextual-menu-show');
        } else {
          menuEl.removeClass('contextual-menu-show');
        }
      }
    } else {
      menuEl.removeClass('contextual-menu-show contextual-menu-swipe-fixed');
    }

    prevScrollPos = scroll;
  }

  function onResize() {
    _options = _options || {};
    if (
      _options.useIconButtons &&
      menuEl &&
      menuEl.length > 0 &&
      menuContainer &&
      menuContainer.length > 0
    ) {
      offsetTop = parseInt(
        window.getComputedStyle(mainContent[0]).paddingTop,
        10
      );
      if (svs.core.detect.formfactor.mobile()) {
        menuEl[0].style.top = offsetTop + _options.stickyMenuOffset + 'px';
        menuEl[0].style.width = window
          .getComputedStyle(menuContainer[0])
          .getPropertyValue('width');
      }
      if (svs.core.detect.formfactor.desktop()) {
        scrollButtons();
      }
    }
  }

  function isScrolledIntoView(scroll) {
    if (menuContainer.length > 0) {
      var rect = menuContainer[0].getBoundingClientRect(),
        anchor = scroll < prevScrollPos ? rect.top : rect.bottom;
      return (
        anchor > offsetTop + _options.stickyMenuOffset && rect.bottom >= 0
      );
    }
  }

  function scrollButtons() {
    var scrollDiff = 12 + 6,
      isMaxScrollLeft = menuEl.scrollLeft() <= scrollDiff,
      isMaxScrollRight =
        menuEl.scrollLeft() + Math.ceil(menuEl.outerWidth()) >=
        menuEl[0].scrollWidth - scrollDiff;

    if (menuEl[0].scrollWidth - scrollDiff > Math.ceil(menuEl.outerWidth())) {
      scrollIconRight.removeClass('hide');
      scrollIconLeft.removeClass('hide');

      if (isMaxScrollLeft) {
        scrollIconLeft.addClass('contextual-menu-scroll-button-hide');
      } else {
        scrollIconLeft.removeClass('contextual-menu-scroll-button-hide');
      }
      if (isMaxScrollRight) {
        scrollIconRight.addClass('contextual-menu-scroll-button-hide');
      } else {
        scrollIconRight.removeClass('contextual-menu-scroll-button-hide');
      }
    } else {
      scrollIconRight.addClass('hide');
      scrollIconLeft.addClass('hide');
    }
  }

  function scrollLeft() {
    menuEl.animate({ scrollLeft: menuEl.scrollLeft() - 350 }, 500);
  }

  function scrollRight() {
    menuEl.animate({ scrollLeft: menuEl.scrollLeft() + 350 }, 500);
  }

  function renderIconButtons(buttons) {
    var hasEnabledButtons = false;
    scrollIconRight = $(
      "<div class='contextual-menu-scroll-button-right contextual-menu-scroll-button-hide " +
      (_options.contextScrollButtonClass
        ? _options.contextScrollButtonClass
        : 'contextual-menu-scroll-button-default') +
      " icon-button'><i class='icon icon-inverted icon-300 icon-menu-right'></i></div>"
    );
    scrollIconLeft = $(
      "<div class='contextual-menu-scroll-button-left contextual-menu-scroll-button-hide " +
      (_options.contextScrollButtonClass
        ? _options.contextScrollButtonClass
        : 'contextual-menu-scroll-button-default') +
      " icon-button'><i class='icon icon-inverted icon-300 icon-menu-left'></i></div>"
    );
    menuContainer = $('.js-context-menu');
    menuEl = $('<nav class="contextual-menu clearfix"/>');
    menuEl.addClass('contextual-menu-swipe');

    if (_options.useFixedMenu) {
      menuContainer.addClass('sticky-context-menu');
    }

    if (
      menuEl.outerWidth() <= menuEl[0].scrollWidth &&
      svs.core.detect.formfactor.desktop()
    ) {
      menuEl.append(scrollIconLeft, scrollIconRight);
    }

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i],
        context = button.context || _options || this,
        iconButton = $(
          '<button class="contextual-menu-swipe-button ' +
          (button.cssClass
            ? button.cssClass
            : 'contextual-menu-swipe-button-default') +
          (button.active ? ' contextual-menu-swipe-button-active' : '') +
          '" title="' +
          button.text +
          '"><span class="contextual-menu-swipe-icon-button icon-button"><i class="icon icon-default icon-300 ' +
          (button.icon ? button.icon : 'icon-games-guide') +
          ' contextual-menu-swipe-icon"></i></span>' +
          button.text +
          '</button>'
        );

      if (!button.disabled) {
        hasEnabledButtons = true;
        iconButton.on('click', { button: button, context: context }, function(
          e
        ) {
          e.preventDefault();
          $.proxy(e.data.button.callback, e.data.context || this)();
        });
        menuEl.append(iconButton);
      }
    }

    if (_options.element) {
      if (!(_options.element instanceof $)) {
        _options.element = $(_options.element);
      }
      if (hasEnabledButtons) {
        _options.element.html(menuEl);
      }
    } else {
      if (hasEnabledButtons) {
        menuContainer.html(menuEl);
      }
    }

    onResize();
  }


  function renderMobileButtons(buttons) {
    var ul = $(
      '<ul class="list-group list-group-default border-0 margin-0" />'
    );

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i],
        disabled = button.disabled ? ' disabled' : '',
        context = button.context || _options,
        li = $(
          '<li class="context-menu-item list-group-item js-clickable js-clickable-delayed-click clickable-list-group-item-default' +
          disabled +
          '"/>'
        ),
        btn = $('<div class="media">');

      if (button.icon) {
        btn.append(
          '<i class="icon-default ' +
          button.icon +
          ' media-object margin-right-1"></i>'
        );
      }

      btn.append(
        '<div class="media-body">' +
        button.text +
        (button.subText
          ? '<br /><span class="fc-grey-600">' + button.subText + '</span>'
          : '') +
        '</div></div>'
      );

      if (!button.disabled) {
        li.on('click', { button: button, context: context }, function(e) {
          e.preventDefault();
          $.proxy(e.data.button.callback, e.data.context || this)();
          toggleVisibility();
        });
      }

      ul.append(li.append(btn));
    }

    $el.find('.contextual-menu').html(ul);
  }
  function getButton(button, disableClick) {
    var context = button.context || _options || this,
      btn,
      btnData = {
        disabled: button.disabled,
        title: button.text,
        linkTitle: button.text,
        transparent:
          button.transparent === undefined ? true : button.transparent,
        inverted: button.inverted === undefined ? false : button.inverted,
        size: button.size === undefined ? '90' : button.size,
        block: button.block === undefined ? false : true,
        class: button.cssClass,
        icon: button.icon
      };
    btnData['icon-position'] = button.iconPosition
      ? button.iconPosition
      : false;

    if (button.type && button.type === 'checkbox') {
      btn = $(
        svs.components.contextual_menu.templates.contextual_checkbox(button)
      );
      if (button.cssClass) {
        btn.addClass(button.cssClass);
      }
      if (button.disabled) {
        btn.find('input').attr('disabled', 'disabled');
      } else {
        btn.on(
          'change',
          'input',
          { button: button, context: context },
          function(e) {
            $.proxy(e.data.button.callback, e.data.context || this)();
          }
        );
      }
    } else if (button.type && button.type === 'icon') {
      btn = $(
        '<button class="icon-button" title="' +
        btnData.title +
        '"><i class="icon icon-300 fc-grey-600 icon-' +
        button.icon +
        '"></i></button>'
      );
      if (!button.disabled && !disableClick) {
        btn.on('click', { button: button, context: context }, function(e) {
          e.preventDefault();
          $.proxy(e.data.button.callback, e.data.context || this)();
        });
      }
    } else {
      btn = $(svs.ui.button.partials.button(btnData));
      if (!button.disabled && !disableClick) {
        btn.on('click', { button: button, context: context }, function(e) {
          e.preventDefault();
          $.proxy(e.data.button.callback, e.data.context || this)();
        });
      }
    }
    return btn;
  }
  function renderTabletButtons(
    leftButtons,
    rightButtons,
    leftButtonsInBlock,
    rightButtonsInBlock
  ) {
    var placeInRows = false,
      contextMenu = $('<nav class="contextual-menu clearfix"/>'),
      buttonGroupClass =
        Object.prototype.hasOwnProperty.call(_options, 'leftButtonsInGroup') &&
          _options.leftButtonsInGroup === false
          ? ''
          : 'btn-group',
      getButtonGroup = function(buttons, buttonGroupCssClass) {
        var btnGroup = $(
          '<div class="' + buttonGroupClass + '"></div>'
        ).addClass(buttonGroupCssClass);
        for (var i = 0; i < buttons.length; i++) {
          var button = getButton(buttons[i]);
          btnGroup.append(button);
        }

        return btnGroup;
      },
      getOrderedButtons = function(buttons) {
        var unorderedButtons = _.groupBy(buttons, 'row'),
          orderedButtons = {};
        Object.keys(unorderedButtons)
          .sort()
          .forEach(function(key) {
            var index = key;
            if (!index || index === 'undefined') {
              index = 0;
            }
            orderedButtons[index] = unorderedButtons[key];
          });
        return orderedButtons;
      };
    var allButtons = [],
      groupedLeftButtons,
      groupedRightButtons,
      buttonRows = [];

    if (!placeInRows) {
      if (leftButtons.length > 0) {
        var btnGroupColLeft = $(
          '<div class="contextual-menu-button-column contextual-menu-button-column-left"/>'
        );
        groupedLeftButtons = getButtonGroup(
          leftButtons,
          leftButtonsInBlock
            ? 'btn-group-block'
            : 'contextual-menu-buttons-left'
        );
        btnGroupColLeft.append(groupedLeftButtons);
        contextMenu.append(btnGroupColLeft);
      }
      if (rightButtons.length > 0) {
        var btnGroupColRight = $(
          '<div class="contextual-menu-button-column contextual-menu-button-column-right"/>'
        );
        groupedRightButtons = getButtonGroup(
          rightButtons,
          rightButtonsInBlock
            ? 'btn-group-block'
            : 'contextual-menu-buttons-right'
        );
        btnGroupColRight.append(groupedRightButtons);
        contextMenu.append(btnGroupColRight);
      }
      contextMenu.attr({
        'data-left-buttons': leftButtons.length,
        'data-right-buttons': rightButtons.length
      });

    } else {
      if (leftButtons) {
        leftButtons.map(function(item) {
          if (!item.row || !item.row === undefined) {
            item.row = 0;
          }
          item.position = 'left';
          return item;
        });
        allButtons = _.union(allButtons, leftButtons);
      }
      if (rightButtons) {
        rightButtons.forEach(function(item) {
          if (!item.row || !item.row === undefined) {
            item.row = 0;
          }
          item.position = 'right';
        });
        allButtons = _.union(allButtons, rightButtons);
      }
      buttonRows = getOrderedButtons(allButtons);
      _.each(buttonRows, function(items) {
        var $row = $('<div class="contextual-menu-row"/>');
        var $left = $(
          svs.ui.button_group.partials.button_group({
            class: 'btn-group-block contextual-menu-row-left'
          })
        );
        var $right = $(
          svs.ui.button_group.partials.button_group({
            class: 'btn-group-block contextual-menu-row-right'
          })
        );

        _.each(items, function(item) {
          var $btn = getButton(item);
          if (item.position === 'right') {
            $right.append($btn);
            $row.append($right);
          } else {
            $left.append($btn);
            $row.append($left);
          }
          if ($right.children().length && $left.children().length) {
            $row.addClass('contextual-menu-row-two-col');
          }
        });
        contextMenu.append($row);
      });
    }
    if (_options.element) {
      if (!(_options.element instanceof $)) {
        _options.element = $(_options.element);
      }
      _options.element.html(contextMenu);
    } else {
      $('.js-context-menu').html(contextMenu);
    }
  }

  function toggleVisibility() {
    if (
      (_menuType === 'button' || _menuType === 'textButton') &&
      Object.prototype.hasOwnProperty.call(_options, 'callback')
    ) {
      var context = Object.prototype.hasOwnProperty.call(_options, 'context')
        ? _options.context
        : this;
      $.proxy(_options.callback, context)();
    } else {
      if (_rendered === false) {
        render();
        _rendered = true;
      }

      var contextMenu = $el.find('.contextual-menu');

      if ($el.hasClass('hide')) {
        contextMenu.css({
          visibility: 'hidden'
        });

        $el.removeClass('hide');

        var width = contextMenu.width(),
          height = contextMenu.height();

        contextMenu.css({
          overflow: 'hidden',
          visibility: 'visible',
          left: 'auto',
          width: 0,
          height: 0
        });

        $el.removeClass('hide');

        contextMenu.animate(
          {
            width: width,
            height: height
          },
          200,
          'easeOut',
          function() {
            contextMenu.css({
              overflow: 'visible'
            });
          }
        );
      } else {
        contextMenu.css({
          overflow: 'hidden',
          left: 'auto'
        });

        contextMenu.animate(
          {
            width: 0,
            height: 0
          },
          200,
          'easeOut',
          function() {
            $el.addClass('hide');

            contextMenu.removeAttr('style');
          }
        );
      }

      var icon = $('.js-top-contextual-icon');
      if (icon.hasClass('icon-menu-down') || icon.hasClass('icon-menu-up')) {
        icon.toggleClass('icon-menu-down').toggleClass('icon-menu-up');
      }

      svs.components.analytics.trackVirtual('contextual-meny');
    }
  }

  function convertButtonsToNewSyntax(buttons) {
    var convertedButtons = [],
      callbackify = function(swedish) {
        swedish =
          'on' +
          swedish
            .replace(/( [a-z])/g, function(s) {
              return s.toUpperCase().replace(' ', '');
            })
            .replace(/[åä]/g, 'a')
            .replace(/[ÅÄ]/g, 'A')
            .replace(/[ö]/g, 'o')
            .replace(/[Ö]/g, 'O')
            .replace(/\W/g, '');
        return swedish;
      };

    for (var i in buttons) {
      if (Object.prototype.hasOwnProperty.call(buttons, i)) {
        var button = {
          text: i,
          callback: _options[callbackify(i)]
        };

        convertedButtons.push(button);
      }
    }

    return convertedButtons;
  }

  function makeInvisible() {
    _isVisible = false;

    if (!svs.core.detect.formfactor.mobile()) {
      $('.contextual-menu').addClass('hide');
    } else {
      $('.js-top-contextual-icon').addClass('hide');
    }
  }

  function makeVisible() {
    _isVisible = true;

    if (!svs.core.detect.formfactor.mobile()) {
      $('.contextual-menu').removeClass('hide');
    } else {
      $('.js-top-contextual-icon').removeClass('hide');
    }
  }

  function close() {
    $el.addClass('hide');

    var icon = $('.js-top-contextual-icon');
    if (icon.hasClass('icon-menu-down') || icon.hasClass('icon-menu-up')) {
      icon.addClass('icon-menu-down').removeClass('icon-menu-up');
    }
  }

  function reset() {
    if ($el) {
      $el.off();
      $el.find('ul>li').off();
      $el.find('.contextual-menu').empty();

      _rendered = false;
    }

    $(window).off('scroll', onScroll);
    $(window).off('resize', onResize);

    $('.js-top-contextual').hide();
  }

  function handleCallbackFromApp(button) {
    var clickedButton;
    if (typeof button === 'string') {
      try {
        button = JSON.parse(button);
      } catch (e) {
        if (e.message.indexOf('JSON Parse error') > -1) {
          var allButtons = _options.rightButtons.concat(_options.leftButtons);
          clickedButton = _.findWhere(allButtons, { text: button });
        }
      }
    }

    var context = Object.prototype.hasOwnProperty.call(_options, 'context')
      ? _options.context
      : this;

    if (
      (_options.menuType === 'button' ||
        _options.menuType === 'textButton') &&
      Object.prototype.hasOwnProperty.call(_options, 'callback')
    ) {
      $.proxy(_options.callback, context)();
    } else if (clickedButton) {
      $.proxy(clickedButton.callback, context)();
    } else {
      if (button.buttonList === 'right') {
        $.proxy(_options.rightButtons[button.id].callback, context)();
      } else {
        $.proxy(_options.leftButtons[button.id].callback, context)();
      }
    }
  }

  return {
    render: render,
    setMenuFunctionality: setMenuFunctionality,
    toggleVisibility: toggleVisibility,
    makeVisible: makeVisible,
    makeInvisible: makeInvisible,
    close: close,
    options: _options,
    handleCallback: handleCallbackFromApp,
    reset: reset
  };
};

svs.components.contextualMenu = new svs.components.ContextualMenu();


 })(window);